import Vue from 'vue'

export default {
  UPDATE_ABOUT_CHAT(state, obj) {
    obj.rootState.AppActiveUser.about = obj.value
  },
  UPDATE_STATUS_CHAT(state, obj) {
    obj.rootState.AppActiveUser.status = obj.value
  },

  // API AFTER
  SEND_CHAT_MESSAGE(state, payload) {
    if (payload.chatData) {
      // If there's already chat. Push msg to existing chat
      state.chats[Object.keys(state.chats).find(key => key == payload.id)].msg.push(payload.msg)
    } else {
      // Create New chat and add msg
      const chatId = payload.id
      Vue.set(state.chats, [chatId], { isPinned: payload.isPinned, msg: [payload.msg] })
    }
  },
  CHANGE_MESSAGE_STATUS(state, payload){
    state.chats[payload.id].msg.find(msg => msg === payload.msg).status = payload.status
  },
  RECEIVE_NEW_MESSAGE(state, payload) {
    if(state.chats[payload.id]) {
      state.chats[payload.id].msg.push(payload.msg)
    } else {
      Vue.set(state.chats, [payload.id], { isPinned: false, msg: [payload.msg] })
    }
  },
  UPDATE_CONTACTS(state, contacts) {
    state.contacts = contacts
  },
  INSERT_CHAT_CONTACT(state, contact){
    state.chatContacts.unshift(contact)
    Vue.set(state.chats, [contact.id], { isPinned: false, msg: [], page:2 })
  },
  INSERT_MESSAGES_TO_CHAT(state, payload){
    const chat = state.chats[payload.id]
    chat.msg.unshift(...payload.msg)
    chat.page += 1
  },
  UPDATE_CHAT_CONTACTS(state, chatContacts) {
    state.chatContacts = chatContacts
  },
  UPDATE_CHATS(state, chats) {
    state.chats = chats
  },
  SET_CHAT_SEARCH_QUERY(state, query) {
    state.chatSearchQuery = query
  },
  MARK_SEEN_ALL_MESSAGES(state, payload) {
    payload.chatData.msg.forEach((msg) => {
      if(payload.isSent === msg.isSent && !msg.readAt){
        msg.isSeen = true
        msg.readAt = payload.readAt
      }
    })
  },
  TOGGLE_IS_PINNED(state, payload) {
    state.chats[Object.keys(state.chats).find(key => key == payload.id)].isPinned = payload.value
  },
  SET_ACTIVE_CHAT_USER(state, val){
    state.activeChatUser = val
  }
}

